<template>
  <v-container>
    <v-alert v-if="breakpoint === 'xs' || breakpoint === 'sm'" type="info" variant="tonal" class="mx-auto mb-4"
      max-width="400" density="compact">
      Use a larger screen for a better experience. This app is best viewed on a tablet or desktop.
    </v-alert>
    <v-card
      :class="['mx-auto', 'pa-2', 'card', { 'mt-8': breakpoint === 'xs' || breakpoint === 'sm', 'mt-16': breakpoint !== 'xs' && breakpoint !== 'sm' }]"
      max-width="400">
      <v-card-item>
        <v-card-title>
          Sign in
        </v-card-title>
      </v-card-item>
      <!-- <v-card-text>
        We will periodically be opening access
      </v-card-text> -->
      <v-form autofill="on">
        <v-text-field v-model="username" name="username" label="Username" type="text" placeholder="username" required
          :rules="usernameRules" variant="outlined" class="mx-2" id="username"></v-text-field>
        <v-text-field v-model="password" name="password" label="Password" type="password" placeholder="password"
          required @keyup.enter="signin" :rules="passwordRules" variant="outlined" class="mx-2" id="password"></v-text-field>
      </v-form>
      <v-card-actions>
        <v-btn @click="signin" text="Go" variant="outlined" :disabled="signinDisabled()"></v-btn>
      </v-card-actions>
    </v-card>
    <div class="mx-auto mt-4 pa-2 access-text text-center">
      <router-link to="/forgot-password" class="d-block mb-2">Forgot Password?</router-link>
      <router-link to="/register">Register here</router-link>
    </div>
  </v-container>
</template>
<script lang="ts">
import { checkEmail } from '@/utils/general'
import { consumePostAuthRedirect } from '@/utils/authRedirect'
import { defaultDashboardPath } from '@/router/dashboardTabs'
import { Options, mixins } from 'vue-class-component'
import { mapGetters } from 'vuex'
import AnalyticsMixin from '@/mixins/AnalyticsMixin'

@Options({
  computed: {
    breakpoint(): string {
      return this.$vuetify.display.name
    },
    ...mapGetters(['authenticated', 'authFailureMessage'])
  },
  watch: {
    breakpoint(value: any) {
      // change layout
    },
    authenticated(value: boolean) {
      if (value) {
        this.redirectAfterSignIn()
      }
    }
  }
})
export default class SignInView extends mixins(AnalyticsMixin) {
  public breakpoint!: string
  public authenticated!: boolean
  public username: string = ''
  public password: string = ''
  public authFailureMessage: string = ''
  private redirecting: boolean = false

  public usernameRules = [
    (v: string) => !!v.trim() || 'Username is required',
    (v: string) => !checkEmail(v.trim()) || 'Username is not an email address.',
  ]

  public passwordRules = [
    (v: string) => !!v || 'Password is required'
  ]

  public async mounted() {
    this.trackComponentView('signin_page');
    await this.$store.dispatch('checkAuth')
    if (this.authenticated) {
      this.redirectAfterSignIn()
    }
  }

  public async signin() {
    this.trackFormInteraction('signin_form', 'submit');
    try {
      if (this.signinDisabled()) return
      const username = this.username.trim()
      this.username = username
      // sign in here
      await this.$store.dispatch('authenticate', { username, password: this.password })
      this.password = ''
      await this.$store.dispatch('checkAuth')
      this.trackEvent('login_success', { method: 'username' });
      if (this.authenticated) {
        this.redirectAfterSignIn()
      }
    } catch (error: any) {
      this.trackEvent('login_failure', { method: 'username', reason: error.message });
    }
  }

  public signinDisabled() {
    const username = this.username.trim()
    return username === '' || checkEmail(username) || !this.password
  }

  private redirectAfterSignIn(): void {
    if (this.redirecting) return
    this.redirecting = true
    const redirect = consumePostAuthRedirect()
    if (redirect?.selectedTab) {
      this.$store.dispatch('setTab', redirect.selectedTab)
    }
    if (redirect?.fullPath && redirect.fullPath !== this.$route.fullPath) {
      this.$router.push(redirect.fullPath)
      return
    }
    this.$router.push(defaultDashboardPath)
  }
}
</script>
<style scoped lang="scss">
.card {
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.access-text {
  max-width: 400px;
}
</style>
